import { Box } from "@mui/material";
import { IThemeProps } from "component/theme";
import styled from "styled-components";

interface IProps {
  disableShadow?: boolean;
  isTabletView?: boolean;
}

export const StyledApprovalForm = styled(Box)<IProps>`
.card-wrap {
    box-shadow: ${({disableShadow}) => disableShadow ? 'none' : '4px 10px 30px 4px rgba(36, 14, 47, 0.06)'};
    border-radius: 12px;
    padding: ${({theme}: IThemeProps) => theme.uptimeSpace[6]}px ${({theme, disableShadow, isTabletView}) => disableShadow ? theme.uptimeSpace[12] : (isTabletView ? theme.uptimeSpace[18] : theme.uptimeSpace[12])}px;
    min-height: 138px;
    background-color: ${({disableShadow}) => disableShadow ? 'transparent' : 'inherit'};
  }
  .uptime-approval-form-body {
    min-height: 100px;
    width: 100%;
    > .MuiGrid-container{
      align-items: flex-start;
    }
  }
  .content-box {
    min-height: 45px;
    .comment-content {
      max-width: 90%;
      word-break: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    > p {
      margin: ${({theme}: IThemeProps) => theme.uptimeSpace[0]}px;
    }
    .word-wrap {
      word-break: break-word;
    }
  }
  .heading5 {
    font-size: ${({theme}: IThemeProps) => theme.uptimeFontSizes.desktop.fz7}px;
    line-height: ${({theme}: IThemeProps) => theme.uptimeLineHeights.desktop.lh9}px;
    font-weight: normal;
    color: ${({theme}: IThemeProps) => theme.uptimeColors.grayScales.black};
    font-weight: 400;
    margin-bottom: ${({theme}: IThemeProps) => theme.uptimeSpace[5]}px;
  }
  .bodyBold {
    font-size: ${({theme}: IThemeProps) => theme.uptimeFontSizes.desktop.fz4}px;
    line-height: ${({theme}: IThemeProps) => theme.uptimeLineHeights.desktop.lh4}px;
    color:  ${({theme}: IThemeProps) => theme.uptimeColors.grayScales.black};
    font-weight: 600;
    margin: ${({theme}: IThemeProps) => theme.uptimeSpace[0]}px ${({theme}: IThemeProps) => theme.uptimeSpace[0]}px ${({theme}: IThemeProps) => theme.uptimeSpace[4]}px;
    line-height: 1.3;
  }
  .bodyRegular {
    font-size: ${({theme}: IThemeProps) => theme.uptimeFontSizes.desktop.fz4}px;
    display: block;
    line-height: 1.3;
    margin: ${({theme}: IThemeProps) => theme.uptimeSpace[0]}px;
    color: ${({theme}: IThemeProps) => theme.uptimeColors.grayScales.darkerGray};
  }
`